import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { PatientConsentPDDEGDUBaseAnimatingComponent } from "./PatientConsentPDDEGDUBaseAnimatingComponent";
import { ConfirmButton, TextButton } from "./PatientConsentManagerShared.styles";
export const DocumentRetrievalRecordsNotFound = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const { isIAS, animate, isAIFlow, onAddProviders, onContinueWithoutSharing } = props;
    let continueButtonText;
    if (isIAS) {
        continueButtonText = t("Continue without accessing records");
    }
    else if (isAIFlow) {
        continueButtonText = t("Continue without connecting records");
    }
    else {
        continueButtonText = t("Continue without sharing records");
    }
    return (_jsx(PatientConsentPDDEGDUBaseAnimatingComponent, { title: t("We need your help to find your records"), supportingText: t("We couldn't automatically find your records. This can happen if your providers aren't supported or have outdated details. Please add them manually to continue."), animate: animate, buttons: _jsxs(_Fragment, { children: [_jsx(ConfirmButton, { onClick: () => onAddProviders(), children: t("Add providers") }), _jsx(TextButton, { onClick: () => onContinueWithoutSharing(), children: continueButtonText })] }) }));
});
addDisplayName(DocumentRetrievalRecordsNotFound, "DocumentRetrievalRecordsNotFound");
